import React from 'react';
import styled from 'styled-components';

const GridContainerWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

interface GridContainerProps {
 children: any,
 className: string,
}

function GridContainer({
  children, className,
}: GridContainerProps) {
  return (
    <GridContainerWrapper className={`${className}`}>
      { children }
    </GridContainerWrapper>
  )
}

export default GridContainer;

GridContainer.defaultProps = {
  className: '',
};
